import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-filter-user-detail',
  templateUrl: './filter-user-detail.component.html',
  styleUrls: ['./filter-user-detail.component.css']
})
export class FilterUserDetailComponent implements OnInit {
  constructor(private location: Location) { }
  @Input() userData: boolean;
  @Input() userFilter;
  ngOnInit() {
  }
  locationBack() {
    this.location.back();
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/skill-matrix/filter-user-detail/filter-user-detail.component.ts